const orderEventsByStartDate = {
    init() {
        let programSidebarNodes = document.querySelectorAll('.mini-tile.mini-tile--aside.program');
        if (programSidebarNodes.length) {
            this._processTiles(programSidebarNodes);
            this._updateTileClassesAndVisibility(programSidebarNodes);
        }

        let programNodes = document.querySelectorAll('#post-part .post-item');
        if (programNodes.length) {
            this._processTiles(programNodes);
            this._updateTileClassesAndVisibility(programNodes);
        }
    },

    _parseDate(dateStr) {
        let [day, month, year, hours = 0, minutes = 0] = dateStr
            .trim()
            .split(/[-\s:]+/)
            .map((part, index) => (index > 1 ? parseInt(part, 10) : parseInt(part, 10) - (index === 1 ? 1 : 0)));
        return new Date(year, month, day, hours, minutes, 0);
    },

    _getValidDates(button) {
        let now = new Date();
        try {
            let datesJson = JSON.parse((button.dataset.datesjson || '').replace(/—/g, '-'));
            return datesJson
                .map(([start, end]) => ({
                    start: this._parseDate(start),
                    end: this._parseDate(end || start),
                }))
                .filter(({ end }) => end >= now);
        } catch {
            return [];
        }
    },

    _getEarliestStartDate(button) {
        let validDates = this._getValidDates(button);
        return validDates.length
            ? Math.min(...validDates.map(({ start }) => start.getTime()))
            : Infinity;
    },

    _processTiles(tiles) {
        Array.from(tiles)
            .map(tile => ({
                tile,
                date: this._getEarliestStartDate(tile.querySelector('.event-dates-json')),
            }))
            .sort((a, b) => a.date - b.date)
            .forEach((item, index) => {
                item.tile.style.order = index;
            });
    },

    _updateTileClassesAndVisibility(tiles) {
        const tilesArray = Array.from(tiles);
        tilesArray.sort((a, b) => parseInt(a.style.order, 10) - parseInt(b.style.order, 10));

        const initialVisibleCount = tilesArray.filter(tile => ! tile.classList.contains('tile-hidden-post')).length;

        tilesArray.forEach((tile, index) => {
            tile.style.order = index;
            if (index < initialVisibleCount) {
                tile.classList.remove('tile-hidden-post');
            } else {
                tile.classList.add('tile-hidden-post');
            }
        });
    }
};

export { orderEventsByStartDate };